import React from 'react';
import { inject, observer } from 'mobx-react';
// import { observe } from 'mobx';
import { withRouter } from 'react-router-dom';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import DatePicker from 'material-ui/DatePicker';
import HttpClient from 'services/HttpClient';
import _ from 'lodash';
import moment from 'moment';
import plus from 'images/plus-1.png'
import copy from 'images/copy.svg'

const COURSE_REQUEST = '/api/v1/courses';
const dateConst = {
  startTime: 'on_site_date',
  endTime: 'off_site_date'
}

@withRouter
@inject('createCourseStore')
@inject('userStore')
@inject('alertStore')
@observer
export default class Courses extends React.Component {
  state = {
    modalOpen: false,
    courses: [],
    confirmationModalOpen: false,
    errors: null
  }

  componentWillMount() {
    const { course } = this.props.createCourseStore;

    if(!course)
      this.props.createCourseStore.initNewCourse();

    this.getCourses();
  }

  getCourses = () => {
    new HttpClient().get(COURSE_REQUEST).then(response => {
      this.setState({
        ...this.state,
        courses: response.body.data.courses
      });
      this.props.onCourseSelect(response.body.data.courses[0]);
    });
  }

  handleSave = e => {
    e.preventDefault();
    const { course } = this.props.createCourseStore;
    const errors = this.handleError();

    if(_.isEmpty(errors)) {
      if(course && course.id) {
        new HttpClient().put(`${COURSE_REQUEST}/${course.id}`, this.props.createCourseStore.course).then(() => {
          this.getCourses();
          this.handleClose();
          this.setState({errors: null});
        }).catch((e) => {
          this.handleError(e.body.data.errors)
        });
      } else {
        new HttpClient().post(COURSE_REQUEST, this.props.createCourseStore.course).then(() => {
          this.getCourses();
          this.handleClose();
          this.setState({errors: null});
        }).catch((e) => {
          this.handleError(e.body.data.errors)
        });
      }
    } else {
      this.setState({errors});
    }
  }

  handleError = () => {
    const {course} = this.props.createCourseStore;
    let newState = {};
    if(!course.title)
      newState = _.assign(newState, {title: 'Title must be entered'});
    if(!course.on_site_date)
      newState = _.assign(newState, {startTime: 'Date must be selected'});
    if(!course.off_site_date)
      newState = _.assign(newState, {endTime: 'Date must be selected'});

    return newState;
  };

  handleOpen = (course) => {
    if (course && course.id) {
      this.props.createCourseStore.setCourse(course);
    } else {
      this.props.createCourseStore.initNewCourse();
    }
    this.setState({ modalOpen: true });
  };

  handleClose = () => {
    this.setState({ modalOpen: false });
    this.props.createCourseStore.initNewCourse();
    document.body.classList.remove('scrollable');
    document.getElementById('app').style = null;
  };

  copyCourse = () => {
    // console.log('copy course with ID = ', course);
  }

  openDeleteConfirmModal = course => {
    this.props.createCourseStore.setCourse(course);
    this.setState({ confirmationModalOpen: true });
  }

  closeDeleteConfirmModal = () => {
    this.props.createCourseStore.initNewCourse();
    this.setState({ confirmationModalOpen: false });
  }

  deleteCourse = () => {
    const { course } = this.props.createCourseStore;
    new HttpClient().delete(`${COURSE_REQUEST}/${course.id}`).then(() => {
      this.getCourses();
      this.closeDeleteConfirmModal();
    }).catch((e) => {
      this.handleError(e.body.data.errors)
    });
  }

  handleChange = (e) => {
    this.props.createCourseStore.handleChange({ [e.target.name]: e.target.value });
  };

  onChangeTime = (date, type) => {
    this.props.createCourseStore.handleDate({ [type]: date });
  }

  coursesListAdmin = () => {
    const selectedCourse = this.props.createCourseStore.course;

    return this.state.courses.map(course => {
      return (
        <div className={`col col-12 col-md-4 course-card ${course.id === selectedCourse.id ? 'selected-course' : ''}`} key={course.id} onClick={() => this.props.onCourseSelect(course)}>
          { this.props.userStore.isAdmin() &&
            <div className="admin-menu-btn">
              <i className='video-admin-menu ic-ellipsis' />
            </div>
          }
          { this.props.userStore.isAdmin() &&
            <div className='courses-controls'>
              <button onClick={() => this.handleOpen(course)} className="menu-i"><i className='ic-edit' /></button>
              <button onClick={() => this.copyCourse(course)} className="menu-i"><img src={copy} alt="copy" /></button>
              <button onClick={() => this.openDeleteConfirmModal(course)} className="menu-i"><i className='ic-close-circle' /></button>
            </div>
          }
          { this.props.userStore.isAdmin() ?
            <span className='period'>{moment(course.on_site_date).format('DD/MM/YYYY')} — {moment(course.off_site_date).format('DD/MM/YYYY')}</span> :
            <span className='period-title'>{course.title}</span>
          }
          <p className='title'>{course.description}</p>
        </div>
      )
    })
  }

  userCourse = (course) => {
    return (
      <div className="current-course">
        <span className='label'>CURRENT COURSE:</span>
        <p className='title'>{course.title}</p>
        <span className='time'>{moment(course.on_site_date, 'DD-MM-YYYY').format('DD/MM/YYYY')} — {moment(course.off_site_date, 'DD-MM-YYYY').format('DD/MM/YYYY')}</span>
        <p className='info'>{course.description}</p>
      </div>
    )
  }

  render() {
    const customContentStyle = {
      height: '100%',
      maxHeight: 'none'
    };
    const { errors } = this.state;
    const { course } = this.props.createCourseStore;
    const startTime = course.on_site_date ? new Date(course.on_site_date) : course.on_site_date;
    const endTime = course.off_site_date ? new Date(course.off_site_date) : course.off_site_date;

    return (
      <div className="courses">{
        // {this.props.userStore.isAdmin() ?
          <div className="col">
            <div className="courses-list">
              {!_.isEmpty(this.state.courses) && this.coursesListAdmin()}
              {this.props.userStore.isAdmin() &&
                <div className="course-card create">
                  <button onClick={this.handleOpen}>
                    <img src={plus} alt="create new course" />
                    <span>create course</span>
                  </button>
                </div>
              }
            </div>
          </div>
          // :
          // <div className="col">
            // {!_.isEmpty(this.state.courses) && this.userCourse(this.state.courses[0])}
          // </div>
        }
        <Dialog
          className="modal-wrapper category-handle"
          title='Are you sure you want to delete this course?'
          modal={true}
          open={this.state.confirmationModalOpen}
          customContentStyle={customContentStyle}
          bodyClassName="modal-content"
          repositionOnUpdate={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={false}>
          <div className="button-set">
            <button className="btn gray small transparanted cancel-btn" type="reset"
              onClick={this.closeDeleteConfirmModal}>No
              </button>
            <button className="btn gray small transparanted apply-btn" type="submit"
              onClick={this.deleteCourse}>Yes
              </button>
          </div>
        </Dialog>
        <Dialog
          className="modal-wrapper category-handle"
          title={`${course && course.id ? 'Edit course' : 'New course'}`}
          modal={true}
          open={this.state.modalOpen}
          customContentStyle={customContentStyle}
          bodyClassName="modal-content"
          repositionOnUpdate={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={false}>
          <form className="create-session form-modal">
            <div className="input-wrap main">
              <TextField
                onChange={this.handleChange}
                className='course-title'
                name="title"
                value={course.title}
                floatingLabelText="Course Title"
                type="text"
                errorText={errors && errors.title}
              />
              <TextField
                // onChange={}
                className='course-price'
                name="price"
                value={course.price}
                floatingLabelText="Price (EUR)"
                type="number"
                disable
              />
            </div>
            <div className="input-wrap">
              <TextField
                onChange={this.handleChange}
                className='course-description'
                name="description"
                value={course.description}
                floatingLabelText="Description"
                type="text"
              />
            </div>
            <div className="input-wrap main">
              <DatePicker
                hintText="Start Time"
                onChange={(event, date) => { this.onChangeTime(date, dateConst.startTime) }}
                value={startTime}
                errorText={errors && errors.startTime}
              />
              <DatePicker
                hintText="End Time"
                onChange={(event, date) => { this.onChangeTime(date, dateConst.endTime) }}
                value={endTime}
                errorText={errors && errors.endTime}
              />
            </div>
            <div className="button-set">
              <button className="btn gray small transparanted cancel-btn" type="reset"
                onClick={this.handleClose}>Cancel
                </button>
              <button className="btn gray small transparanted apply-btn" type="submit"
                onClick={this.handleSave}>{`${course && course.id ? 'Save changes' : 'Create course'}`}
                </button>
            </div>
          </form>
        </Dialog>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/categories/components/Courses.js